import { render, staticRenderFns } from "./StatusFilterMenu.vue?vue&type=template&id=04fba78e&scoped=true"
import script from "./StatusFilterMenu.vue?vue&type=script&lang=js"
export * from "./StatusFilterMenu.vue?vue&type=script&lang=js"
import style0 from "./StatusFilterMenu.vue?vue&type=style&index=0&id=04fba78e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fba78e",
  null
  
)

export default component.exports